import { Map } from 'immutable';

import * as constants from '../constants';

const initialState = new Map({
  isLoading: false,
});

const biometricsAuthenticationReducer = (state = initialState, { type }) => {
  switch (type) {
    case constants.MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION.REQUEST:
      return state.set('isLoading', true);
    case constants.MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION.SUCCESS:
    case constants.MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION.FAILURE:
      return state.set('isLoading', false);
    default:
      return state;
  }
};

export default biometricsAuthenticationReducer;
export { initialState };
